import { useEffect, useState } from 'react';
import Home from './Components/Home';
import './app.scss';

import { base_Url, getQuery, makeApiCal, POST } from './AppConfig';
import Loader from './Components/Loader/Loader';
import Error from './Components/Loader/Error';

function Scratch() {
	const [apiData, updateApiData] = useState();
	const [Loading, updateLoading] = useState(true);
	const [apiError, checkApiError] = useState(false);
	const [responseData, setResponseData] = useState(null);

	useEffect(() => {
		getApiData();

		const action = {
			method: POST,
			route: 'v2/storeDeeplink',
			body: {
				deeplink: {
					screen: 'STUDENT_END_REWARDS',
					paramOne: '',
					paramTwo: '',
					paramTracking: 'StudentRewardTracking',
				},
			},
			storeData: (e) => console.log(e),
			catchError: (e) => console.error(e),
		};

		makeApiCal(action);
	}, []);

	useEffect(() => {
		if (apiData) {
			updateLoading(false);
		}
	}, [apiData]);

	const tryAgain = () => {
		updateLoading(true);
		getApiData();
	};

	const getApiData = () => {
		let token = getQuery()['token'] || sessionStorage.getItem('scratchToken');
		sessionStorage.setItem('scratchToken', token);

		fetch(`${base_Url}/v2/course/campaign/student/award/list`, {
			method: 'get',
			headers: {
				'Content-Type': 'application/json',
				'x-access-token': token,
			},
		})
			.then((res) => {
				return res.json();
			})
			.then((res) => {
				if (res.status === 'success') {
					updateApiData(res && res.data);
				} else {
					updateLoading(false);
					checkApiError(true);
				}
			});
	};

	const sendScreenFlag = ({ orderId, promoTypeId }) => {
		let token = getQuery()['token'] || sessionStorage.getItem('scratchToken');
		const body = {
			orderId: orderId,
			promoTypeId: promoTypeId,
		};
		fetch(`${base_Url}/v2/course/campaign/student/award/redeemVoucher`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-access-token': token,
			},
			body: JSON.stringify(body),
		})
			.then((res) => {
				return res.json();
			})
			.then((data) => {
				setResponseData(data?.data?.coupon);
				setTimeout(() => {
					getApiData();
				}, 1000);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	return (
		<div className="App">
			{Loading ? (
				<Loader />
			) : apiError ? (
				<Error tryAgain={tryAgain} />
			) : (
				<Home
					data={apiData}
					postApi={sendScreenFlag}
					responseData={responseData}
				/>
			)}
		</div>
	);
}

export default Scratch;
